import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const TeachersDayBlog = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Teacher's Day: Recognizing the Heroes in Our Classrooms</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>

          <Row className="mt-3">
            <Col md={12}>
              <Image src="/graphics/images/teachersday2.webp" alt="teachers day" fluid />
              <p className="mt-4">
                Teacher's Day is a special occasion to honor the incredible contributions of educators around the world. In India, this day is celebrated on September 5th, the birthday of Dr. Sarvepalli Radhakrishnan, a revered philosopher and the second President of India. Dr. Radhakrishnan believed that teachers are the pillars of society, shaping the future through their dedication to educating young minds. 
              </p>
              <p>
                Teachers do much more than teach—they inspire, motivate, and challenge us to reach our full potential. They play a vital role in developing our character, encouraging creativity, and fostering a lifelong love of learning. From kindergarten to university, every teacher leaves a lasting impression on their students.
              </p>
              <p>
                Simple gestures like wCelebrating Teacher's Day is a way to express our gratitude and appreciation for all that teachers do. Simple gestures like writing a heartfelt thank-you note, organizing a small celebration, or sharing a memorable story can go a long way in showing appreciation.
              </p>
              <p>As we celebrate Teacher's Day, let’s take a moment to thank the teachers who have made a difference in our lives. Their hard work and dedication shape not just individuals but entire communities, paving the way for a better future.</p>
              <p>
                Happy Teacher's Day to all the amazing educators who inspire us every day!
              </p>

              <h4 className="sub-heads">Here are some heartfelt Happy Teachers Day wishes:</h4>

              {["teacher'sDay.webp", "teachers_day.webp", "teacher_wish.webp", "teachers_wishes.webp", "teachers.webp", "teacher.webp"].map((img, index) => (
                <Image key={index} src={`/graphics/images/${img}`} alt="teacher day" fluid className="mt-3" height="500px" />
              ))}

              {["Happy Teachers Day! Your passion for teaching and your love for your students makes you a truly remarkable teacher.",
                "To my favorite teacher, Happy Teachers Day! You have taught me more than just the curriculum; you have taught me valuable life lessons.",
                "Thank you for being the light in our lives, showing us the way, and guiding us through our academic journey. Happy Teachers Day!",
                "Wishing you a Happy Teachers Day! Your hard work and dedication have made a lasting impact on so many students.",
                "Happy Teachers Day! Thank you for your endless patience, care, and dedication. You make learning an adventure!"]
                .map((quote, index) => (
                  <p key={index} className="mt-4"><b>&#x275D; {quote} &#x275E;</b></p>
                ))}

              <center>
                <a href="https://youtu.be/R0R-dL3JZQ4">
                  <h5>Watch more on Teacher's Day</h5>
                  <Image src="/graphics/images/ytd-btn.png" alt="youtube" />
                </a>
              </center>
            </Col>
          </Row>
        </Col>
        
        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost/>
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default TeachersDayBlog;